"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewindIcon = function RewindIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "quiver-rewind-icon", width: "14px", height: "10px", viewBox: "0 0 14 10" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "#FFFFFF", fillRule: "evenodd" },
      _react2.default.createElement("polygon", { points: "7 10 -2.84217094e-13 4.96539307 7 0" }),
      _react2.default.createElement("polygon", { points: "14 10 7 4.96539307 14 0" })
    )
  );
};

exports.default = RewindIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamRewind/RewindIcon.js
// module id = 542
// module chunks = 11